// components/Testimonials.js — Use Cases Section
import React from 'react';
import './Testimonials.css';

function Testimonials() {
  const useCases = [
    {
      icon: '🤖',
      title: 'RAG Pipelines',
      description: 'Store and retrieve millions of document embeddings for LLM context windows. Combine vector similarity with full-text search in a single SQL query.',
    },
    {
      icon: '🔍',
      title: 'Semantic Search',
      description: 'Power search across images, text, and audio with pgvector on S3-backed storage. Sub-second latency at any scale.',
    },
    {
      icon: '📊',
      title: 'AI Feature Stores',
      description: 'Serve real-time ML features from a single Postgres endpoint. Versioned, branched, and tiered storage keeps costs under control.',
    },
  ];

  return (
    <section id="use-cases" className="use-cases">
      <div className="use-cases__container">
        <p className="section-eyebrow">Use Cases</p>
        <h2>Built for Modern AI Workloads</h2>
        <p className="section-subtitle">
          From retrieval-augmented generation to production feature serving.
        </p>
        <div className="use-cases__grid">
          {useCases.map((uc, index) => (
            <div key={index} className="use-case-card">
              <div className="use-case-card__icon">{uc.icon}</div>
              <h3>{uc.title}</h3>
              <p>{uc.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
